import { MenuItem } from '@mui/material';
import { GridExportMenuItemProps, useGridApiContext } from '@mui/x-data-grid-pro';
import { useToast } from '../../../contexts/ToastContext';
import { exportToExcel, getExportData } from '../../../utils/export';

const ExcelExportMenuOption = (props: GridExportMenuItemProps<Record<string, never>> & { allColumns?: boolean }) => {
  const apiRef = useGridApiContext();
  const { hideMenu, allColumns = false } = props;
  const { enqueueSnackbar } = useToast();

  const handleExport = () => {
    hideMenu?.();
    void exportToExcel(getExportData(apiRef, { allColumns })).catch(() => {
      enqueueSnackbar({ message: 'Something went wrong.', variant: 'error' });
    });
  };

  return <MenuItem onClick={handleExport}>Export as Excel</MenuItem>;
};

export default ExcelExportMenuOption;
